const studyAbroad = {
  path: 'studyAbroad',
  component: resolve => require(['../../../components/pages/studyAbroad'], resolve)
}

export default studyAbroad



// WEBPACK FOOTER //
// ./src/router/pages/studyAbroad/index.js